export default function () {
  return {
    faqs: [],
    showDeleteDialog: false,
    deletingId: null,
    orderChanged: false,
  }
}
